export const getRoleHierarchy = role => {
  const hierarchy = {
    GM: ['CSM'],
    CSM: ['BDM'],
    BDM: ['UM'],
    UM: ['SP'],
    SP: [],
  };
  return hierarchy[role] || [];
};

export const getRoleIcon = role => {
  const icons = {
    GM: '👑',
    CSM: '🎯',
    BDM: '📈',
    UM: '👥',
    SP: '💼',
  };
  return icons[role] || '👤';
};

export const getRoleColor = (role, level) => {
  const colors = {
    GM: 'from-purple-600 to-purple-700',
    CSM: 'from-blue-600 to-blue-700',
    BDM: 'from-teal-600 to-teal-700',
    UM: 'from-green-600 to-green-700',
    SP: 'from-orange-600 to-orange-700',
  };
  return colors[role] || 'from-gray-600 to-gray-700';
};
